<template>
  <div class="animated fadeIn vld-parent custom-100" >
    <b-row>
      <b-col sm="12">
        <searchBar ref="searchBar"
                   :selected-date="currentDate"
                   :on-search="queryData"
        ></searchBar>
      </b-col>
    </b-row>
    <b-row class="custom-flex-1 mt-0">
      <b-col sm="12">
        <auftraegeTable ref="auftraegeTable"
                        :table-data="data"
                        @page-changed="setPage"
        ></auftraegeTable>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import searchBar from '../predefined_tours/TourExecutionSearchbar.vue'
import auftraegeTable from '../predefined_tours/TourExecutionTable.vue'
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import {
  arrayBufferToBase64,
  decryptAES,
  decryptFile,
  decryptTodos,
  encryptAES,
  encryptServerTodos
} from "@/shared/crypto";
import {DateTime as LuxonDateTime} from "luxon";
import {parseTimestamp} from "@/shared/dates";



export default {
  name: "TaskExecutionView",
  components: {
    'searchBar':searchBar, 'auftraegeTable': auftraegeTable},
  data() {
    return {
      // SearchbarProps
      data: [],
      currentPage: 1,
      currentDate: null,
      query: {
        status: "A",
        date: LuxonDateTime.local().toISO(),
        dateType: "Y",
        page: 1,
      },
      afterFirstQuery: false,
    }
  },
  props:{
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
  },
  created() {
    this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
    this.parseQuery()
    this.$nextTick(() => {
      this.currentDate = LuxonDateTime.local().toISO();
      this.$refs.searchBar.setQuery(this.query);
      this.queryData(this.query.status,
          this.query.date, this.query.dateType);
    });
  },
  methods: {
    showLoader() {
      if (this.loader === undefined) {
        this.loader = this.$loading.show();
      }
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    parseQuery() {
      let query = this.$route.query;
      if (query.date) {
        this.query = {
          status: query.status,
          date: query.date,
          dateType: query.dateType,
          page: query.page,
        }
      }
    },
    responseOkFetch(response) {
      this.$refs.auftraegeTable.currentPage = 1;
      this.$refs.searchBar.onFirstSearch();
      if (response.status === 200) {
        let data = response.body;
        this.decryptData(data);
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    setPage(page) {
      this.query.page = page;
      this.$router.push({query: this.query}).then(() => {}).catch(err => {});
    },
    queryData(status, currentDate, dateType) {
      console.log("Here")
      let d = parseTimestamp(new Date(Date.parse(currentDate)), "DD.MM.YYYY")
      d = encodeURIComponent(d)
      this.query = {
        status: status,
        date: currentDate,
        dateType: dateType,
        page: this.query.page,
      }
      this.$router.replace({query: this.query}).then(() => {
        this.showLoader();
        this.$http.get(
            Server_URL+'/auftragsbuch/data/predefined_tour_execution/'+this.$route.params.id+
            "?status_type="+status+
            "&selected_date_type="+dateType+
            "&selected_start_date="+d
        ).then(this.responseOkFetch, this.responseError)
      }).catch(e => {
        this.showLoader();
        this.$http.get(
            Server_URL+'/auftragsbuch/data/predefined_tour_execution/'+this.$route.params.id+
            "?status_type="+status+
            "&selected_date_type="+dateType+
            "&selected_start_date="+d
        ).then(this.responseOkFetch, this.responseError)
      });
    },
    async decryptData(data) {
      // todo make faster/ less import
      for (let i = 0; i < data.length; i++) {
        data[i]._showDetails = true;
        data[i].selected = false;
        data[i]._rowVariant = '';
        try {
          if (data[i].description !== null && data[i].description !== "") {
            data[i].description = await decryptAES(sessionStorage.getItem("aes"), data[i].description);
          }
        } catch (e) {
          //console.log(e)
        }
      }
      this.hideLoader();
      this.data = data;
      this.$nextTick(() => {
        if (!this.afterFirstQuery) {
          this.$refs.auftraegeTable.changePage(this.query.page);
        }
        this.afterFirstQuery = true;
      })
    },
  },
}
</script>

<style scoped>
::v-deep .tab-content {
  display: none !important;
}

.bauhof-border {
  border-left: 5px solid #FBFBFB;
  border-right: 5px solid #FBFBFB;
}

</style>
<style>
.toast-pre-wrap {
  white-space: pre-wrap;
}
</style>
